import { render } from "./contractExtend.vue?vue&type=template&id=24916874&ts=true"
import script from "./contractExtend.vue?vue&type=script&lang=ts"
export * from "./contractExtend.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__